<template>
    <button type="button" class="btn rounded-pill" :class="btnClass" style="min-width: 110px;" :disabled="store.loading">
        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" v-if="store.loading"></span>
        <slot><i class="fa-solid fa-chevron-left"></i>Zurück</slot>
    </button>
</template>
<script setup>
import { computed } from "vue"
import { store } from "../../store";
const props = defineProps({
    variant: {
        type: String,
        default: 'primary'
    }
})
const btnClass = computed(() => 'btn-outline-' + props.variant)
</script>
